import { Link } from 'react-router-dom';
import { XCircle } from 'lucide-react';

export const CheckoutCancel = () => {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="max-w-md mx-auto px-4 text-center" data-testid="payment-cancelled">
        <div className="bg-white rounded-xl p-12">
          <div className="w-20 h-20 bg-muted rounded-full flex items-center justify-center mx-auto mb-6">
            <XCircle className="w-12 h-12 text-muted-foreground" />
          </div>
          <h2 className="font-heading font-semibold text-3xl mb-4">Paiement Annulé</h2>
          <p className="text-muted-foreground mb-8">
            Votre paiement a été annulé. Vos articles sont toujours dans votre panier.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link
              to="/panier"
              className="bg-primary text-primary-foreground hover:bg-primary/90 h-12 px-8 rounded-full font-medium transition-all hover:scale-105 active:scale-95 shadow-lg shadow-primary/20 inline-flex items-center justify-center"
              data-testid="back-to-cart-btn"
            >
              Retour au panier
            </Link>
            <Link
              to="/"
              className="bg-white border border-input hover:bg-muted h-12 px-8 rounded-full font-medium transition-all inline-flex items-center justify-center"
              data-testid="back-home-link"
            >
              Retour à l'accueil
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};